import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ErrorService {

  handleError(error: HttpErrorResponse): Observable<never> {
    let message = 'An unknown error occurred.';
    if (error.error instanceof ErrorEvent) {
      message = `Client error: ${error.error.message}`;
    } else if (error.error?.detail) {
      message = `Server error: ${error.error.detail}`;
    } else {
      message = `Server returned ${error.status}: ${error.message}`;
    }
    return throwError(() => new Error(message));
  }
}
